import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { BASE_URL } from '../constants'
import { IProjectToEmployeeLink } from '../model/interfaces'
import { getTokenFromLocalStorage } from '../../utils'
export const projectEmployeeLinksApi = createApi({
  reducerPath: 'projectEmployeeLinksApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${BASE_URL}/projectEmployeeLink`,
    headers: { Authorization: `Bearer ${getTokenFromLocalStorage()}` }
  }),
  tagTypes: ['ProjectEmployeeLinks'],
  endpoints: (builder) => ({
    getProjectEmployeeLinks: builder.query<IProjectToEmployeeLink[], void>({
      query: () => {
        return {
          url: '',
          headers: { Authorization: `Bearer ${getTokenFromLocalStorage()}` }
        }
      },
      providesTags: ['ProjectEmployeeLinks']
    }),
    createProjectEmployeeLinks: builder.mutation<void, IProjectToEmployeeLink>({
      query: (projectEmployeeLink: IProjectToEmployeeLink) => ({
        method: 'POST',
        url: '',
        body: projectEmployeeLink,
        headers: { Authorization: `Bearer ${getTokenFromLocalStorage()}` }
      }),
      invalidatesTags: ['ProjectEmployeeLinks']
    }),
    updateProjectEmployeeLinks: builder.mutation<void, IProjectToEmployeeLink>({
      query: (projectEmployeeLink: IProjectToEmployeeLink) => ({
        method: 'PUT',
        url: `/${projectEmployeeLink._id}`,
        body: projectEmployeeLink,
        headers: { Authorization: `Bearer ${getTokenFromLocalStorage()}` }
      }),
      invalidatesTags: ['ProjectEmployeeLinks']
    }),
    deleteProjectEmployeeLink: builder.mutation<void, IProjectToEmployeeLink>({
      query: (projectEmployeeLink: IProjectToEmployeeLink) => ({
        method: 'DELETE',
        url: `/${projectEmployeeLink._id}`,
        headers: { Authorization: `Bearer ${getTokenFromLocalStorage()}` }
      }),
      invalidatesTags: ['ProjectEmployeeLinks']
    })
  })
})

export const {
  useGetProjectEmployeeLinksQuery,
  useLazyGetProjectEmployeeLinksQuery,
  useUpdateProjectEmployeeLinksMutation,
  useCreateProjectEmployeeLinksMutation,
  useDeleteProjectEmployeeLinkMutation
} = projectEmployeeLinksApi
